import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isAuthenticated } from "../requests/api_request";
import { Spin } from "antd";

interface PrivateRoutesProp {
  element: React.ReactElement;
}

const PrivateRoute = ({ element }: PrivateRoutesProp) => {
  const [Auth, setAuth] = useState("none");
  let load = false;
  const navigate = useNavigate();

  useEffect(() => {
    const Auth_checker = async () => {
      setAuth(await isAuthenticated());
    };
    Auth_checker();
  }, []);

  if (Auth !== "none") {
    load = true;
  }

  if (!load) {
    return (
      <div className=" w-full flex items-center justify-center mt-[20%]">
        <Spin size="large" />
      </div>
    );
  }

  if (Auth == null) {
    navigate("/signin", { replace: true });
    window.location.reload();
  }

  return element;
};

export default PrivateRoute;
